// extracted by mini-css-extract-plugin
module.exports = {"animation":"Animation-module--animation--p5zK9"};